const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Account } from './Account';
import { MomentOwned } from './MomentOwned';

export interface DuoCount {
  setID: number,
  playID: number,
  count: number
}

export class Portfolio extends BaseObject {
  public account: Account = null
  public moments: MomentOwned[] = null
  public valueFMV: number = null
  public valueFMV2?: number = null
  public costBasis: number = null
  public numMoments: number = null
  public computedDate: Date = null
  public duoCounts: {[ duoCountKey: string ]: DuoCount } = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super()
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (typeof this.computedDate === 'string') this.computedDate = new Date(this.computedDate)
    if (this.moments) this.moments = this.moments.map((po) => new MomentOwned(po))
  }

  public isSafe(): boolean {
    return true
  }

}




(async () => {
})();
